import formModelStore from "../../store/FormModelStore";
import {Calculation, Selection} from "../../../src/application/Contracts";
import InputMethod = Calculation.InputMethod;
import OperatingMode = Calculation.OperatingMode;
import WaterSystemOptionModel = Calculation.WaterSystemOptionModel;
import {upperFirst, sum} from "lodash";
import TankType = Selection.TankType;
import TankFamily = Selection.TankFamily;
import ProductFamily = Selection.ProductFamily;

export const IsInstantaneousWasSelectedOnPreviousStep = (): boolean => {
    if (formModelStore.formModel.inputMethod.inputMethod.value === InputMethod.InstallationType) {
        return formModelStore.formModel.inputMethod.installationTypeCalculation?.selectedUnitModel?.value?.operatingMode == OperatingMode.Instantaneous
            || formModelStore.formModel.inputMethod.installationTypeCalculation?.selectedUnitModel?.value?.operatingMode == OperatingMode.PrimaryTank;
    }
    if (formModelStore.formModel.inputMethod.inputMethod.value === InputMethod.Capacity) {
        return formModelStore.formModel.inputMethod.capacityCalculation?.instantaneous?.value;
    }
    if (formModelStore.formModel.inputMethod.inputMethod.value === InputMethod.ProductCatalog) {
        return formModelStore.formModel.activeDirect;
    }
    return false;
}

export const ShowTankSelectionStep = (): boolean => {
    if (formModelStore.formModel.inputMethod.inputMethod.value === InputMethod.InstallationType) {
        if (!formModelStore.formModel.inputMethod.installationTypeCalculation?.selectedUnitModel?.value) {
            return false;
        }
        if (formModelStore.formModel.inputMethod.installationTypeCalculation?.selectedUnitModel?.value?.operatingMode == OperatingMode.Instantaneous
            || formModelStore.formModel.inputMethod.installationTypeCalculation?.selectedUnitModel?.value?.operatingMode == OperatingMode.PrimaryTank) {
            return formModelStore.formModel.inputMethod.installationTypeCalculation?.primaryTankAvailableCapacity?.value > 0;
        } else {
            return true;
        }
    }
    if (formModelStore.formModel.inputMethod.inputMethod.value === InputMethod.Capacity) {
        return (formModelStore.formModel.inputMethod.capacityCalculation?.instantaneous?.value && formModelStore.formModel.inputMethod.capacityCalculation?.primaryTank?.value === true)
            || formModelStore.formModel.inputMethod.capacityCalculation?.semiInstantaneous?.value;
    }
    return formModelStore.formModel.activeDirect && formModelStore.formModel.tankSelection?.matchingTankUnit?.tankFamily?.value !== "No";
}
export const ShowWaterSystemSelectionStep = (): boolean => {
    if (formModelStore.formModel.inputMethod.inputMethod.value !== InputMethod.ProductCatalog) {
        return true;
    }
    return formModelStore.formModel.inputMethod?.productCatalogCalculation?.selectedProduct?.value?.name !== upperFirst(TankFamily.AquaTank);
}
export const IsPrimaryTankWasSelected = (tankType: TankType | undefined): boolean => {
    if (formModelStore.formModel.inputMethod.inputMethod.value === InputMethod.InstallationType) {
        if (!formModelStore.formModel.inputMethod.installationTypeCalculation?.selectedUnitModel?.value) {
            return false;
        }
        return formModelStore.formModel.inputMethod.installationTypeCalculation?.selectedUnitModel?.value?.operatingMode == OperatingMode.PrimaryTank;
    }
    if (formModelStore.formModel.inputMethod.inputMethod.value === InputMethod.Capacity) {
        return formModelStore.formModel.inputMethod.capacityCalculation?.primaryTank?.value === true;
    }
    if (formModelStore.formModel.inputMethod.inputMethod.value == InputMethod.ProductCatalog) {
        return tankType === TankType.PrimaryTank;
    }
    return formModelStore.formModel.activeDirect && formModelStore.formModel.tankSelection?.matchingTankUnit?.tankFamily?.value.indexOf("Prim") > -1;
}

export const IsTankProduct = (): boolean => {
    return formModelStore.formModel.inputMethod.productCatalogCalculation?.selectedProduct?.value?.isTank;
}

export const IsProductSelected = (productFamily: ProductFamily): boolean => {
    return formModelStore.formModel.inputMethod.productCatalogCalculation?.selectedProduct?.value?.name === upperFirst(productFamily);
}

export const TankOnSite = (): boolean => {
    return formModelStore.formModel.tankSelection.matchingTankSelection.tankOnSite.value;
}

export const GetTWSWeight = (): number => {
    return formModelStore.formModel.waterSystem?.results?.value?.matchingWaterSystemTechnicalDataModel?.generalModel?.twsWeight ?? 0;
}

export const GetTankWeight = (): number => {
    const technicalData = formModelStore.formModel.tankSelection?.results?.value?.tankTechnicalData;
    return (technicalData?.weight ?? 0) * (technicalData?.quantity ?? 0);
}

export const GetOptionsWeight = (options: WaterSystemOptionModel[]): number => {
    return sum(options?.map(x => x.weight));
}